import { Component, Input } from '@angular/core';
import { OverviewSeriesPoint } from '../../models/overview.model';

@Component({
  selector: 'app-usage-chart-card',
  standalone: false,
  templateUrl: './usage-chart-card.html',
})
export class UsageChartCard {
  @Input({ required: true }) series: OverviewSeriesPoint[] = [];

  get points() {
    return this.series.map(s => ({ label: s.date, value: s.value }));
  }
}
